import { CandidateStatus } from '~/domain/PermanentJobs';
import { ShareIcon } from '~/images/icons';
import { Colors } from '~/themes/colors';

interface IInviteColumnCellProps {
  candidateId: string;
  jobPostingId: string;
  officeStatus: CandidateStatus;
}

export const InviteColumnCell = ({
  candidateId,
  jobPostingId,
  officeStatus,
}: IInviteColumnCellProps) => {
  const isHired = officeStatus === CandidateStatus.Hired;
  const isRejected = officeStatus === CandidateStatus.Rejected;

  const canInvite = !isHired && !isRejected;

  if (!canInvite) {
    return null;
  }

  return (
    <button
      aria-label="Invite candidate"
      data-candidate-id={candidateId}
      data-job-posting-id={jobPostingId}
      data-testid="invite-column-cell"
      style={{ background: 'transparent', width: 'fit-content', marginLeft: 16 }}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <ShareIcon color={Colors.secondary_500} />
    </button>
  );
};
